import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormPackage({
  packageSelect,
  callback,
  title,
  button_text,
  button_variant,
  infoServiceTypes,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    id: null,
    name: '',
    code: '',
    description: '',
    state: true,
    service_types: [],
  });
  const callbackRef = useRef(callback);
  const handleClose = () => setShow(false);
  const handleShow = async () => {
    const endpoint = packageSelect ? `/config/package/${packageSelect}` : '/config/package/0';
    const infoPackage = await get(endpoint);
    if (infoPackage.success) {
      const { id, name, code, description, state, service_types, all_service_types } = infoPackage.data;
      setForm({
        id,
        name: name || '',
        code: code || '',
        description: description || '',
        state: state !== undefined ? state : true,
        service_types: service_types ? service_types.map(st => st.id) : [],
      });
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = {
      name: infoForm.name,
      code: infoForm.code,
      description: infoForm.description,
      state: infoForm.state,
      service_types: infoForm.service_types,
    };

    if (packageSelect) {
      respo = await put(`/config/package/modify/${packageSelect}`, body);
      msg = 'Paquete editado correctamente';
    } else {
      respo = await post('/config/package/create', body);
      msg = 'Paquete creado correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.data || respo.message;
    }
    setForm({
      id: null,
      name: '',
      code: '',
      description: '',
      state: true,
      service_types: [],
    });
    handleClose();
    callbackRef.current(variant, msg);
  };

  const validCheckedServiceType = (id) => {
    if (infoForm.service_types?.length > 0) {
      const valid = infoForm.service_types.findIndex((element) => element === id) >= 0;
      return valid;
    }
    return false;
  };

  const handleFormSelect = ({ target }) => {
    const value = parseInt(target.name);
    const arrayForm = [...infoForm.service_types];

    if (target.checked) {
      arrayForm.push(value);
    } else {
      const control = arrayForm.findIndex((element) => element === value);
      if (control >= 0) arrayForm.splice(control, 1);
    }
    setForm({ ...infoForm, service_types: arrayForm });
  };

  const cleanForm = () => {
    setForm({
      id: null,
      name: '',
      code: '',
      description: '',
      state: true,
      service_types: [],
    });
  };

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow()}
      />

      <Modal animation={false} size="lg" fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label htmlFor="name">Nombre</Form.Label>
                <Form.Control
                  name="name"
                  value={infoForm.name}
                  onChange={(e) => handleForm(e)}
                  type="text"
                />
              </Col>
              <Col md={6}>
                <Form.Label htmlFor="code">Código</Form.Label>
                <Form.Control
                  name="code"
                  value={infoForm.code}
                  onChange={(e) => handleForm(e)}
                  type="text"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Label htmlFor="description">Descripción</Form.Label>
                <Form.Control
                  name="description"
                  value={infoForm.description}
                  onChange={(e) => handleForm(e)}
                  type="text"
                  as="textarea"
                  rows={2}
                />
              </Col>
            </Row>
            <Form.Check
              className="mb-4"
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />
            <Row className="mt-3">Tipos de Servicio</Row>
            <Row className="mt-3">
              {infoServiceTypes && infoServiceTypes.length > 0 ? (
                <Row>
                  {infoServiceTypes.map((element, i) => (
                    <Col key={i} lg={4} sm={12} md={6}>
                      <Form.Check
                        type="switch"
                        id={`service-${element.id}`}
                        name={element.id}
                        label={`${element.code} - ${element.name}`}
                        checked={validCheckedServiceType(element.id)}
                        onChange={(e) => handleFormSelect(e)}
                      />
                    </Col>
                  ))}
                </Row>
              ) : (
                <Col>
                  <p className="text-muted">No hay tipos de servicio disponibles</p>
                </Col>
              )}
            </Row>

            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary" onClick={cleanForm}>Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormPackage;
